import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { DASHBOARD_ROUTE } from "../../../../../routes";
import authServices from "../../../../../services/authServices";
import dataProvider from "../../../../../services/dataProvider";
import AssociatedTask from "../../../common/associated-task";
import { markTaskComplete } from "../../../common/mark-task-complete";
import { SUBMITTED_FORMS_ROUTE } from "../../../dashboard-routes";
import getAssociatedTask from "../getAssociatedTask";
import SelfDeclaration from "./common/self-declaration";
import StepWiseForm from "./common/step-wise";
import YesNoFormGenerator from "./common/yesno-form-generator";
import * as formMaps from "./form-maps/half-yearly-files-review-form-map";

const HalfYearlyFilesReviewForm = ({ bucket, formType, formTitle }) => {
    const history = useHistory();
    const location = useLocation();

    let baseState = {
        formType,
        formTitle,
        bucket,
        nameOfPersonCompletingForm: "",
        dateOfFormCompletionInString: "",
        dateOfFormCompletionInMilliSeconds: 0,
        tncAgreed: false,
        licenseeIncharge: "",
        partisOfBusinessResponsibleFor: "",
        trusAccountResponsibleFor: "",
        detailsOfNonCompliance: "",
        detailsOfNonComplianceSF1: "",
        detailsOfNonComplianceSF2: "",
        detailsOfNonComplianceSF3: "",
        detailsOfNonCompliancePMF1: "",
        detailsOfNonCompliancePMF2: "",
        detailsOfNonCompliancePMF3: "",
        detailsOfNonComplianceTAT: "",
        acknowledgementName: "",
    };

    const [formState, setFormState] = useState(baseState);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [associatedTask, setAssociatedTask] = useState(null);
    const [completeTask, setCompleteTask] = useState(true);

    useEffect(() => {
        if (location?.state?.editForm === true) {
            if (location?.state?.formState) {
                setEditMode(true);
                let editFormState = location.state.formState;

                // add all extra fields that is not in formMap
                let cleanEditFormState = {
                    formType,
                    formTitle,
                    bucket,
                    nameOfPersonCompletingForm: editFormState.nameOfPersonCompletingForm,
                    dateOfFormCompletionInString: editFormState.dateOfFormCompletionInString,
                    dateOfFormCompletionInMilliSeconds: editFormState.dateOfFormCompletionInMilliSeconds,
                    tncAgreed: editFormState.tncAgreed === "true",
                    licenseeIncharge: editFormState.licenseeIncharge,
                    partisOfBusinessResponsibleFor: editFormState.partisOfBusinessResponsibleFor,
                    trusAccountResponsibleFor: editFormState.trusAccountResponsibleFor,
                    detailsOfNonCompliance: editFormState.detailsOfNonCompliance,
                    detailsOfNonComplianceSF1: editFormState.detailsOfNonComplianceSF1,
                    detailsOfNonComplianceSF2: editFormState.detailsOfNonComplianceSF2,
                    detailsOfNonComplianceSF3: editFormState.detailsOfNonComplianceSF3,
                    detailsOfNonCompliancePMF1: editFormState.detailsOfNonCompliancePMF1,
                    detailsOfNonCompliancePMF2: editFormState.detailsOfNonCompliancePMF2,
                    detailsOfNonCompliancePMF3: editFormState.detailsOfNonCompliancePMF3,
                    detailsOfNonComplianceTAT: editFormState.detailsOfNonComplianceTAT,
                    acknowledgementName: editFormState.acknowledgementName,
                    editFormId: editFormState.id,
                };

                // add yes no fields
                parseMapData(cleanEditFormState, editFormState, formMaps.page1);
                parseMapData(cleanEditFormState, editFormState, formMaps.salesFilesHeader);
                parseMapData(cleanEditFormState, editFormState, formMaps.getSalesFileList(1));
                parseMapData(cleanEditFormState, editFormState, formMaps.getSalesFileList(2));
                parseMapData(cleanEditFormState, editFormState, formMaps.getSalesFileList(3));
                parseMapData(cleanEditFormState, editFormState, formMaps.propertyFilesHeader);
                parseMapData(cleanEditFormState, editFormState, formMaps.getPropertyFileList(1));
                parseMapData(cleanEditFormState, editFormState, formMaps.getPropertyFileList(2));
                parseMapData(cleanEditFormState, editFormState, formMaps.getPropertyFileList(3));
                parseMapData(cleanEditFormState, editFormState, formMaps.TrustAcountsForm);

                //console.log("Clean Form", cleanEditFormState);
                setFormState(cleanEditFormState);
                setIsFetching(true);
                getAssociatedTask(formType)
                    .then((res) => {
                        // console.log("RES",res);
                        setIsFetching(false);
                        if (res.data && res.data.length > 0) {
                            let task = res.data[0];
                            setAssociatedTask(task);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
    }, []);

    function parseMapData(cleanEditFormData, editFormState, formMap) {
        Object.keys(formMap).forEach((section) => {
            formMap[section].forEach((field) => {
                cleanEditFormData[field.id] = editFormState[field.id] === "true";
            });
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMsg("");
        setErrorMsg("");

        let endPoint = editMode ? "forms-editFormDetails" : "forms-addFormDetails";
        var data = new FormData();
        var jsonData = {}; // only used for debug purpose

        for (var key in formState) {
            data.append(key, formState[key]);
            jsonData[key] = formState[key];
        }

        //console.log("SENT FROM DATA", jsonData);

        var config = {
            method: "post",
            url: dataProvider.baseUrl + endPoint,
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                //console.log("submit form", response);
                
                if (response.data.status === "success") {
                    if (completeTask && associatedTask) {
                        markTaskComplete(associatedTask.id).then((res) => {
                            // console.log("TASK COM", res);
                            if (res.data.status === "success") {
                                history.push({
                                    pathname: DASHBOARD_ROUTE + SUBMITTED_FORMS_ROUTE,
                                    state: {
                                        successMsg:
                                            editMode === true
                                                ? "Form Updated Successfully"
                                                : "Form Submitted Successfully",
                                    },
                                });
                            } else {
                                setIsLoading(false);
                                setErrorMsg("Unable to Complete the Task");
                            }
                        });
                    } else {
                        history.push({
                            pathname: DASHBOARD_ROUTE + SUBMITTED_FORMS_ROUTE,
                            state: {
                                successMsg:
                                    editMode === true ? "Form Updated Successfully" : "Form Submitted Successfully",
                            },
                        });
                    }
                } else {
                    setIsLoading(false);
                    setErrorMsg("Something Went Wrong");
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                setErrorMsg(error.message);
                console.error(error);
            });
    }

    return (
        <div id={formType}>
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom">
                    <h5 className="m-0">{formTitle}</h5>
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {isFetching ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Form Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="container-fluid p-3">
                        <div className="card p-3">
                            <div className="d-flex justify-content-center">
                                <form className="w-100" style={{ maxWidth: "60rem" }} onSubmit={handleSubmit}>
                                    <StepWiseForm>
                                        <PageOne formState={formState} setFormState={setFormState} />
                                        <SalesFileReviewHeader formState={formState} setFormState={setFormState} />
                                        <SalesFilePage n="2" formState={formState} setFormState={setFormState} />
                                        <SalesFilePage n="3" formState={formState} setFormState={setFormState} />
                                        <PropertyFileReviewHeader formState={formState} setFormState={setFormState} />
                                        <PropertyFilePage n="2" formState={formState} setFormState={setFormState} />
                                        <PropertyFilePage n="3" formState={formState} setFormState={setFormState} />
                                        <TrustAccountPage formState={formState} setFormState={setFormState} />
                                        <div>
                                            <Acknowledgement formState={formState} setFormState={setFormState} />

                                            {associatedTask && (
                                                <AssociatedTask
                                                    task={associatedTask}
                                                    completeTask={completeTask}
                                                    setCompleteTask={setCompleteTask}
                                                />
                                            )}

                                            <SelfDeclaration
                                                formState={formState}
                                                setFormState={setFormState}
                                                isLoading={isLoading}
                                                editMode={editMode}
                                            />
                                        </div>
                                    </StepWiseForm>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HalfYearlyFilesReviewForm;

const PageOne = ({ formState, setFormState }) => {
    return (
        <div>
            <div className="d-flex mb-3 mt-5">
                <div className="d-flex align-items-center" style={{ flex: "1 0 50%" }}>
                    <label htmlFor="licenseeIncharge" className="form-label">
                        Licensee in charge:
                    </label>
                </div>
                <div style={{ flex: "1 0 50%" }}>
                    <input
                        id="licenseeIncharge"
                        type="text"
                        className="form-control"
                        value={formState.licenseeIncharge}
                        onChange={(e) => setFormState((fs) => ({ ...fs, licenseeIncharge: e.target.value }))}
                    />
                </div>
            </div>
            <div className="d-flex mb-3">
                <div className="d-flex align-items-center" style={{ flex: "1 0 50%" }}>
                    <label htmlFor="partisOfBusinessResponsibleFor" className="form-label">
                        Partis of Business Responsible For:
                    </label>
                </div>
                <div style={{ flex: "1 0 50%" }}>
                    <input
                        id="partisOfBusinessResponsibleFor"
                        type="text"
                        className="form-control"
                        value={formState.partisOfBusinessResponsibleFor}
                        onChange={(e) =>
                            setFormState((fs) => ({ ...fs, partisOfBusinessResponsibleFor: e.target.value }))
                        }
                    />
                </div>
            </div>
            <div className="d-flex mb-3">
                <div className="d-flex align-items-center" style={{ flex: "1 0 50%" }}>
                    <label htmlFor="trusAccountResponsibleFor" className="form-label">
                        Trus Account/s Responsible For:
                    </label>
                </div>
                <div style={{ flex: "1 0 50%" }}>
                    <input
                        id="trusAccountResponsibleFor"
                        type="text"
                        className="form-control"
                        value={formState.trusAccountResponsibleFor}
                        onChange={(e) => setFormState((fs) => ({ ...fs, trusAccountResponsibleFor: e.target.value }))}
                    />
                </div>
            </div>

            <YesNoFormGenerator formMap={formMaps.page1} formState={formState} setFormState={setFormState} />

            <div className="mt-5">
                <label htmlFor="">Details of non-compliance (if relevant):</label>
                <textarea
                    id=""
                    className="form-control mt-2"
                    value={formState.detailsOfNonCompliance}
                    onChange={(e) => setFormState((fs) => ({ ...fs, detailsOfNonCompliance: e.target.value }))}
                />
            </div>
        </div>
    );
};

const SalesFileReviewHeader = ({ formState, setFormState }) => {
    return (
        <div className="mt-5">
            <YesNoFormGenerator formMap={formMaps.salesFilesHeader} formState={formState} setFormState={setFormState} />

            <div className="mt-4">A minimum of 3 sales files must be reviewed at each 6 monthly interval.</div>

            <SalesFilePage n="1" formState={formState} setFormState={setFormState} />
        </div>
    );
};

const PropertyFileReviewHeader = ({ formState, setFormState }) => {
    return (
        <div className="mt-5">
            <YesNoFormGenerator
                formMap={formMaps.propertyFilesHeader}
                formState={formState}
                setFormState={setFormState}
            />

            <div className="mt-4">A minimum of 3 property management files per month must be reviewed each month</div>

            <PropertyFilePage n="1" formState={formState} setFormState={setFormState} />
        </div>
    );
};

const SalesFilePage = ({ n, formState, setFormState }) => {
    return (
        <div className="mt-5" key={n}>
            <h5>SALES FILE #{n}</h5>

            <div>
                <b>Sales file reviewed:</b>
            </div>
            <div>Does the sales file contain the following?</div>

            <YesNoFormGenerator
                formMap={formMaps.getSalesFileList(n)}
                formState={formState}
                setFormState={setFormState}
            />

            <div className="mt-5">
                <label htmlFor="">Details of non-compliance (if relevant):</label>
                <textarea
                    id=""
                    className="form-control mt-2"
                    value={formState[`detailsOfNonComplianceSF${n}`]}
                    onChange={(e) =>
                        setFormState((fs) => ({ ...fs, [`detailsOfNonComplianceSF${n}`]: e.target.value }))
                    }
                />
            </div>
        </div>
    );
};

const PropertyFilePage = ({ n, formState, setFormState }) => {
    return (
        <div className="mt-5" key={n}>
            <h5>PROPERTY MANAGEMENT FILE #{n}</h5>

            <div>
                <b>Property management file reviewed:</b>
            </div>
            <div>Does the sales file contain the following?</div>

            <YesNoFormGenerator
                formMap={formMaps.getPropertyFileList(n)}
                formState={formState}
                setFormState={setFormState}
            />

            <div className="mt-5">
                <label htmlFor="">Details of non-compliance (if relevant):</label>
                <textarea
                    id=""
                    className="form-control mt-2"
                    value={formState[`detailsOfNonCompliancePMF${n}`]}
                    onChange={(e) =>
                        setFormState((fs) => ({ ...fs, [`detailsOfNonCompliancePMF${n}`]: e.target.value }))
                    }
                />
            </div>
        </div>
    );
};

const TrustAccountPage = ({ formState, setFormState }) => {
    return (
        <div className="mt-5">
            <h5>Trust Accounts transactions (review last 3 x P.M end of month documents)</h5>

            <div>Have the following reviews been undertaken?</div>

            <YesNoFormGenerator formMap={formMaps.TrustAcountsForm} formState={formState} setFormState={setFormState} />

            <div className="mt-5">
                <label htmlFor="">Details of non-compliance (if relevant):</label>
                <textarea
                    id=""
                    className="form-control mt-2"
                    value={formState[`detailsOfNonComplianceTAT`]}
                    onChange={(e) => setFormState((fs) => ({ ...fs, [`detailsOfNonComplianceTAT`]: e.target.value }))}
                />
            </div>
        </div>
    );
};

const Acknowledgement = ({ formState, setFormState }) => {
    return (
        <div className="mt-5 mb-4">
            <h5 className="mb-4">Acknowledgement</h5>

            <div>
                <span>I,</span>
                <input
                    type="text"
                    value={formState.acknowledgementName}
                    onChange={(e) => setFormState((fs) => ({ ...fs, acknowledgementName: e.target.value }))}
                    placeholder="Enter Name"
                    className="form-control no-border border-2 p-0 mx-2 border-top-0 border-end-0 border-start-0 d-inline"
                    style={{ width: "26ch", borderRadius: "0" }}
                />
                <span>
                    ,acknowledge that I have carried out the above monthly review and confirm that my responses are true
                    and correct.
                </span>
            </div>
        </div>
    );
};
